import { Components, Inputs } from "@thisgorilla/primate-ds";
import { useContext, useEffect, useMemo, useState } from "react";
import styled from "styled-components";

import { CenterPanelContext } from "..";
import { API_CALLS } from "../../../../../API/api_calls";
import { actions, useAppDispatch, useAppSelector } from "../../../../../redux";
import { CircleProps } from "../../../../../redux/slices/circles/circles";
import { FlexRow, FlexRowSpaced } from "../../../../Common/Styles";
import CircleList from "./CircleList";
import CircleModal from "./CircleModal";
import NewsFeedFilterProps from "./NewsFeedFilter";

const newsFeedFilterOption = [
  { label: "All", value: "all" },
  { label: "Newest", value: "newest" },
  { label: "Most relevant", value: "most_relevant" },
];

const NewsFeedFilter = ({
  selectedNewsFeedFilter,
  setSelectedNewsFeedFilter,
}: NewsFeedFilterProps.IProps) => {
  const dispatch = useAppDispatch();
  const { selectedCircle } = useContext(CenterPanelContext);
  const [circleListOpen, setCircleListOpen] = useState(false);
  const { createCircleOpen, listOfCircles } = useAppSelector(
    (state) => state.circle
  );

  useEffect(() => {
    API_CALLS.CIRCLE.getListCircles();
  }, []);

  const updatedCircles = useMemo(() => {
    return selectedCircle.map((c) => {
      return listOfCircles.find(
        (circle) => circle.id === c.id
      ) as CircleProps.Circle;
    });
  }, [listOfCircles, selectedCircle]);

  return (
    <FilterContainer>
      <CircleFilterContainer>
        <Inputs.Search
          fieldName="newsfeed-filter"
          handleSelect={(option) => {
            if (option.label === selectedNewsFeedFilter.label) return;
            setSelectedNewsFeedFilter(option);
            dispatch(actions.newsfeed.setPage(1));
          }}
          idPrefix="newsfeed-filter"
          isRequired={false}
          onChangeHandler={() => {}}
          value={selectedNewsFeedFilter.label}
          size="Small"
          options={newsFeedFilterOption}
          fieldType="Select"
        />
      </CircleFilterContainer>

      <Components.SplitButton
        IconPosition="left"
        icon={updatedCircles.length === 0 ? "Circle" : undefined}
        iconColor={"white"}
        title={
          updatedCircles.length > 0 && (
            <IconContainer>
              {updatedCircles.map((circle) => (
                <Components.Icon
                  key={circle.id}
                  type="Circle"
                  size="16px"
                  color={circle.colour}
                />
              ))}
            </IconContainer>
          )
        }
        size="small"
        variant="secondary"
        ListIconsPosition="right"
        leftBtnstyle={`
          background: ${
            updatedCircles.length === 0 &&
            "linear-gradient(92.51deg, #1e96f2 2.1%, #b175fd 112.77%)"
          };
          border-color:${updatedCircles.length > 0 && "#1E96F2"};
          border-radius:4px;
         svg path {
          stroke-width: 3px;
        }`}
        rightBtnstyle="display: none;"
        onLeftClick={() => {
          setCircleListOpen(true);
        }}
      />

      {createCircleOpen && <CircleModal modalOpen={createCircleOpen} />}
      {circleListOpen && <CircleList setCircleListOpen={setCircleListOpen} />}
    </FilterContainer>
  );
};

export default NewsFeedFilter;

const FilterContainer = styled(FlexRowSpaced)`
  position: relative;
  box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-m"]};
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-overlay"].value};
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem
    ${({ theme }) => theme.spacing["spacing-5"].value}rem;
`;

const CircleFilterContainer = styled.div`
  & input {
    font-size: ${({ theme }) => theme.typography.Body.M["font-size"]}rem;
    line-height: ${({ theme }) => theme.typography.Body.M["line-height"]}rem;
    padding: ${({ theme }) => theme.spacing["spacing-1"].value}rem
      ${({ theme }) => theme.spacing["spacing-7"].value}rem
      ${({ theme }) => theme.spacing["spacing-1"].value}rem
      ${({ theme }) => theme.spacing["spacing-3"].value}rem;
    caret-color: transparent;
    width: 134px;
  }
`;

const IconContainer = styled(FlexRow)`
  gap: 0px;
  & svg {
    margin-left: -6px;
    &:first-child {
      margin-left: 0px;
    }
  }
`;
